// extracted by css-extract-rspack-plugin
export default {"cls1":"ConfirmationModal-cls1_fLo","cls2":"ConfirmationModal-cls2_Y5C ConfirmationModal-cls1_fLo"};